
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import '../Assets/Css/home.css';
import '../Assets/Css/product.css';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Button } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';


import wheatImg from '../Assets/Image/wheatseed.png';
import soybeanImg from '../Assets/Image/soyabeanseed.png';
import paddyImg from '../Assets/Image/padyseed.png';
import vegetablesImg from '../Assets/Image/vegetableseed.png';
import organicImg from '../Assets/Image/fertilizersandpesticides.png';
import irrigationImg from '../Assets/Image/Agrieuipment.png';

export default function Products() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    AOS.refresh();
  }, []);

  //       const productSlides = [
  //   {
  //     title: "Wheat Seeds",
  //     image: wheatImg,
  //     description: "Premium wheat seeds designed for high yield and disease resistance."
  //   },
  //   {
  //     title: "Soybean Seeds",
  //     image: soybeanImg,
  //     description: "Genetically advanced soybean seeds for sustainable farming."
  //   },
  //   {
  //     title: "Paddy Seeds",
  //     image: paddyImg,
  //     description: "High-yield paddy seeds optimized for Indian climates."
  //   },
  //   {
  //     title: "Vegetable Seeds",
  //     image: vegetablesImg,
  //     description: "Diverse vegetable seed varieties for commercial and home farming."
  //   },
  //   {
  //     title: "Organic Fertilizers & Pesticides",
  //     image: organicImg,
  //     description: "Chemical-free organic solutions to enrich your soil and protect crops."
  //   },
  //   {
  //     title: "Agri Equipment & Irrigation Kits",
  //     image: irrigationImg,
  //     description: "Modern equipment and micro-irrigation kits to boost productivity."
  //   }
  // ];

  const productSlides = [
    {
      title: "Wheat Seeds",
      image: wheatImg,
      description: "Premium wheat seeds designed for high yield and disease resistance.",
      features: [
        "High quality and certified",
        "Excellent disease resistance",
        "Improves yield significantly",
        "Adaptable to various soil types"
      ]
    },
    {
      title: "Soybean Seeds",
      image: soybeanImg,
      description: "Genetically advanced soybean seeds for sustainable farming.",
      features: [
        "Genetically optimized for growth",
        "Rich in protein content",
        "Suited for crop rotation systems",
        "Better oil extraction potential"
      ]
    },
    {
      title: "Paddy Seeds",
      image: paddyImg,
      description: "High-yield paddy seeds optimized for Indian climates.",
      features: [
        "Improved grain quality",
        "Early maturity variants",
        "Withstands floods and droughts",
        "Backed by government certifications"
      ]
    },
    {
      title: "Vegetable Seeds",
      image: vegetablesImg,
      description: "Diverse vegetable seed varieties for commercial and home farming.",
      features: [
        "Wide variety of vegetable crops",
        "Fast germination rates",
        "Ideal for both open and protected fields",
        "Treated for enhanced shelf life"
      ]
    },
    {
      title: "Organic Fertilizers & Pesticides",
      image: organicImg,
      description: "Chemical-free organic solutions to enrich your soil and protect crops.",
      features: [
        "Eco-friendly and non-toxic",
        "Improves soil health and fertility",
        "Reduces pest and disease risks",
        "Government-approved for organic use"
      ]
    },
    {
      title: "Agri Equipment & Irrigation Kits",
      image: irrigationImg,
      description: "Modern equipment and micro-irrigation kits to boost productivity.",
      features: [
        "Efficient water usage systems",
        "Suitable for all crop types",
        "Durable and weather-resistant",
        "Easy installation and maintenance"
      ]
    }
  ];


  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {

      role: "Farmer – Maharashtra",
      message:
        "Hiranand Agri Solutions helped me switch to high-yield organic farming. Their team guided me through every step of the way.",
    },
    {

      role: "Agri Dealer – Uttar Pradesh",
      message:
        "From soil testing to product training, their support has helped me grow my agri-input business more confidently.",
    },
    {

      role: "Franchise Owner – Karnataka",
      message:
        "Becoming a Hiranand franchisee has been life-changing. Their branding, logistics, and advisory are world-class.",
    },
    {

      role: "Organic Vegetable Farmer – Madhya Pradesh",
      message:
        "Thanks to their quality seeds and timely training, my vegetable yield has doubled with better prices in local markets.",
    },
    {

      role: "Student, Agri Workshop – Rajasthan",
      message:
        "I attended their training seminar, and it was insightful. Now I feel ready to launch my own sustainable farm.",
    },
    {

      role: "Agri Consultant – Punjab",
      message:
        "The expert insights provided by Hiranand Agri Solutions helped our team implement smarter irrigation and crop planning strategies. Truly professional and impactful.",
    }
  ];

  
  const phoneNumber = "7772036678"; 
const checkAvailabilityMessage = "Hi, I'm checking availability for the product.";
  const orderNowMessage = "Hi, I'd like to place an order.";

  const generateWhatsAppLink = (message) =>
    `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div style={{ minHeight: '100vh' }}>

      <Helmet>
        <title>Our Products | Hiranand Agri Solutions Pvt. Ltd.</title>
        <meta
          name="description"
          content="Explore our wide range of premium agricultural products including certified seeds, organic fertilizers, pesticides, modern agri-equipment, and irrigation kits for sustainable farming."
        />
        <meta
          name="keywords"
          content="agricultural products, wheat seeds, soybean seeds, paddy seeds, vegetable seeds, organic fertilizers, pesticides, agri tools, irrigation kits, farming equipment"
        />
        <meta name="author" content="Hiranand Agri Solutions Pvt. Ltd." />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Our Products | Hiranand Agri Solutions Pvt. Ltd." />
        <meta
          property="og:description"
          content="Discover high-yield seeds, eco-friendly fertilizers, and modern agri-equipment tailored for Indian farmers. Quality assured and government certified."
        />
        <meta property="og:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" /> {/* Replace with product banner if available */}
        <meta property="og:url" content="https://hiranandagrisolutions.com/products" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Our Products | Hiranand Agri Solutions Pvt. Ltd." />
        <meta
          name="twitter:description"
          content="High-quality seeds, fertilizers, pesticides, and irrigation kits to support every stage of farming. See how our products empower Indian farmers."
        />
        <meta name="twitter:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" />

        <link rel="canonical" href="https://hiranandagrisolutions.com/products" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      {/* Banner */}
      <div className="banner3-section d-flex align-items-center justify-content-center">
        <div className="banner3-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">Our Products</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
            High-quality seeds, fertilizers, and modern agri-tools for every stage of farming.
          </p>
        </div>
      </div>

      <section className="product-slider-section py-5 ">
        <div className="container text-center p-3">
          <h3 className="fw-bold section-title mb-5" data-aos="fade-down" data-aos-delay="100">
            Our <span style={{ color: '#16343E' }}>Products </span>
            <span className="title-decoration">  </span>
          </h3>

          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            centeredSlides
            loop
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
            }}
            data-aos="zoom-in" data-aos-delay="100"
          >
            {productSlides.map((item, idx) => (
              <SwiperSlide key={idx}>
                <div className={`product-slide-card ${activeIndex === idx ? 'active' : ''}`}>
                  <img src={item.image} alt={item.title} className="img-fluid rounded" />
                  <h6 className="mt-3">{item.title}</h6>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="mt-4 px-3">
            <p className="text-muted description-box">{productSlides[activeIndex].description}</p>
          </div>
        </div>
      </section>

      <section className="deep-product-info py-5  " style={{ backgroundColor: '#f7f1e4' }}>
        <Container>
          <div className="text-center">
            <h3 className="section-title mb-5" data-aos="fade-down" data-aos-delay="100">
              Explore <span style={{ color: '#16343E' }}> Our Products </span>
              <span className="title-decoration"></span>
            </h3>
          </div>

          {productSlides.map((product, idx) => (
            <Row className="align-items-center mb-5" key={idx} data-aos="fade-up" data-aos-delay={idx * 100}>
              <Col md={6} className={idx % 2 !== 0 ? 'order-md-2' : ''} style={{ marginBottom: '20px' }}>
                <div className="image-box text-center">
                  <img src={product.image} alt={product.title}
                    className="img-fluid rounded shadow"
                    style={{ height: '270px', width: '300px' }}
                  />
                </div>
              </Col>

              <Col md={6} className={idx % 2 !== 0 ? 'order-md-1' : ''}>
                <div className="product-content">
                  <h4 className="fw-bold text-center" style={{ color: '#6F583A' }}>{product.title}</h4>
                  <p className="text-muted text-center">{product.description}</p>
                  <ul className="feature-list" style={{ listStyle: 'none' }}>
                    {product.features.map((point, i) => (
                      <li key={i}>✔️ {point}</li>
                    ))}
                  </ul>
                  {/* <div className="text-center mt-3">
                    <Button variant="outline-success" className="me-3 px-4 py-2 rounded-pill">Check Availability</Button>
                    <Button variant="success" className="px-4 py-2 rounded-pill">Order Now</Button>
                  </div> */}

 <div className="text-center mt-3">
      <a
        href={generateWhatsAppLink(checkAvailabilityMessage)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button variant="outline-success" className="me-3 px-4 py-2 rounded-pill">
          Check Availability
        </Button>
      </a>

      <a
        href={generateWhatsAppLink(orderNowMessage)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button variant="success" className="px-4 py-2 rounded-pill">
          Order Now
        </Button>
      </a>
    </div>

                </div>
              </Col>
            </Row>
          ))}
        </Container>
      </section>

      <section className="testimonial-carousel-section my-5">
        <div className="container py-3 ">
          <Row className="align-items-center justify-content-center flex-md-row m-0">
            <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
              Voices of <span style={{ color: '#16343E' }}>Trust & Transformation</span>
              <span className="title-decoration mb-2"></span>
            </h3>
            <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
              Hear how Hiranand Agri Solutions is empowering farmers and entrepreneurs across India.
            </p>
            <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 4000 }}
                pagination={{ clickable: true }}
                loop
                spaceBetween={30}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 1 },
                  992: { slidesPerView: 1 },
                }}
              >
                {testimonials.map((testimonial, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="testimonial-agri-card">
                      {/* <div className="quote-agri-icon">❝</div> */}
                      <p className="testimonial-agri-text">{testimonial.message}</p>
                      <div className="agri-client-info">
                        <img
                          src={require('../Assets/Image/farmer1.jpg')}
                          alt={testimonial.name}
                          className="agri-avatar"
                        />
                        <div>
                          <div className="agri-name">{testimonial.name}</div>
                          <small className="text-muted">{testimonial.role}</small>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>





            </Col>
          </Row>
        </div>
      </section>


    </div>
  );
}

